<template>
  <div style="width: 100vw;height: 100vh;">
    <div id="preViewPdf"></div>
  </div>
</template>
<script>
import Pdfh5 from "pdfh5"
import "pdfh5/css/pdfh5.css"
export default {
  props: {
    pdfUrl: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      visible: false,
      pdfh5: null
    }
  },
  mounted() {
    if (this.pdfUrl) {
      this.openPdf()
    }
  },
  methods:{
    openPdf(){
      this.visible = true
      //实例化
      this.pdfh5 = new Pdfh5("#preViewPdf", {
        pdfurl: this.pdfUrl
      })
    },
  }
}
</script>
